module.exports = __webpack_public_path__ + "media/images/metronic/datatables/sort_asc_disabled-ba64a5dbc753bf9cbd80672a399f89cf.png";